exports.default = {
  'sms_login': 'SMS Login',
  'pwd_login': 'Password Login',
  'please_enter_your_mobile_number_or_email': 'Please enter your mobile number or email',
  'please_enter_your_pwd': 'Please enter your password',
  'forgot_password': 'Forgot password?',
  'no_account': 'No account yet?',
  'register_new_account': 'Register new account',
  'login_failed': 'Login failed',
  'login_success': 'Login successful',
  'verification_title': 'Please enter verification code',
  'code_sent_to_email': 'Verification code has been sent to your email',
  'code_sent_to_phone': 'Verification code has been sent to your phone',
  'verification_sent': 'Verification code has been sent to your email or phone',
  'enter_password': 'Please enter your password',
  'enter_account_password': 'Please enter your account login password',
  'verification_failed': 'Verification failed',
  'verification_success': 'Verification successful',
  'not_received_code': 'Did not receive verification code? Resend later ({time})',
  'resend_code': 'Did not receive verification code? Click to resend',
  'continue': 'Continue',
  'back': 'Back',
  'code_sent': 'Verification code sent, please check',
  'sms_retrieval_password': 'Retrieve password by SMS',
  'mail_retrieval_password': 'Retrieve password by email',
  'enter_mobile_number': 'Please enter mobile number',
  'verification_code_input': 'Please enter verification code',
  'get_verification_code': 'Get verification code',
  'please_set_the_password': 'Please set password',
  'enter_the_password_again': 'Enter password again',
  'reading_consent': 'Read and agree to',
  'user_agreement': 'AgentStore Service Agreement and Privacy Terms',
  'forget_reset': 'Reset',
  'existing_account_number': 'Already have an account?',
  'log_in_now': 'Login now',
  'enter_mail': 'Please enter email',
  'please_enter_your_mobile_number': 'Please enter your mobile number',
  'please_enter_the_verification_code': 'Please enter verification code',
  'please_confirm_the_password_again': 'Please confirm password again',
  'please_keep_the_same_password_twice': 'Please keep the password the same twice',
  'please_enter_your_email': 'Please enter your email',
  'input_the_phone_number_correctly': 'Please enter the correct mobile number',
  'password_check_error': 'Password must contain 8-16 characters, including at least uppercase and lowercase letters, numbers',
  'email_check_error': 'Please enter a valid email address',
  'login_title': 'Login to PAITEAMS',
  'login_title_prefix': 'Login to',
  'welcome_text': 'Welcome back!',
  'google_login': 'Login with Google account',
  'phone_login': 'Phone login',
  'email_login': 'Email login',
  'password_login': 'Password login',
  'or': 'or',
  'email_address': 'Email address',
  'email_placeholder': 'Please enter your email address',
  'phone_number': 'Phone number',
  'phone_placeholder': 'Please enter your phone number',
  'username_label': 'Phone/Email',
  'username_placeholder': 'Please enter your account',
  'password_title': 'Please enter password',
  'password_desc': 'Please enter your account login password',
  'login_button': 'Login',
  'password_error': 'Password error',
  'mobile_registration': 'Mobile registration',
  'mailbox_registration': 'Email registration',
  'register': 'Register',
  'authentication_failed': 'Authentication failed',
  'invite_you': 'invites you to use Paiteams',
  'welcome_use': 'Welcome to use Paiteams',
  'register_to_get': 'Register to get ',
  'new_user_points': 'new user credits',
  'brand_logo_alt': 'Paiteams logo',
  'back_home': 'Back',
  'hero_title_prefix': 'Unlock your',
  'hero_title_highlight': 'potential',
  'hero_phrase_ready': 'Your AI Expert Team is ready',
  'hero_phrase_workflows': 'Streamline complex workflows',
  'hero_phrase_deliver': 'Design. Develop. Deliver',
  'feature_automation': 'AI-powered workflow automation',
  'feature_security': 'Enterprise-grade security',
  'feature_collaboration': 'Seamless team collaboration',
  'dialog_kicker': 'PAITEAMS ACCESS',
  'dialog_title': 'Sign in to keep creating',
  'dialog_subtitle': 'Use a verification code to sign in. New accounts are created automatically.',
  'dialog_close': 'Close login dialog',
  'login_methods': 'Login methods',
  'phone_code_login': 'Phone',
  'email_code_login': 'Email',
  'verification_code_label': 'Verification code',
  'phone_code_placeholder': 'Enter the 6-digit SMS code',
  'email_code_placeholder': 'Enter the 6-digit email code',
  'send_code': 'Get code',
  'resend_after': 'Resend in {time}s',
  'sending_code': 'Sending verification code…',
  'send_code_failed': 'Failed to send verification code. Please try again.',
  'verification_code_invalid': 'Please enter the 6-digit verification code',
  'please_enter_complete_code': 'Please enter the complete 6-digit code.',
  'incorrect_verification_code': 'Incorrect verification code. Please try again.',
  'code_sent_to_contact': 'Code sent to {contact}',
  'edit_contact': 'Edit login account',
  'verification_digit': 'Verification digit {index}',
  'verification_success_redirecting': 'Verified! Redirecting…',
  'verify_and_login': 'Verify & Login',
  'agreement_prefix': 'I have read and agree to the',
  'terms_of_service': 'Terms of Service',
  'terms': 'Terms',
  'privacy_policy': 'Privacy Policy',
  'agreement_and': 'and',
  'agreement_suffix': '.',
  'agreement_required': 'Please read and agree to the terms first',
  'other_login_methods': 'Other ways to sign in',
  'login_in_progress': 'Signing in',
  'login_error': 'Login error. Please try again.',
  'google_redirecting': 'Opening Google',
  'google_redirect_failed': 'Unable to open Google sign-in right now',
  'wechat_login': 'WeChat login',
  'wechat_login_pending': 'WeChat sign-in is coming soon',
  'invite_invalid': 'This invite code is invalid or expired. You can still sign in.',
  'visual_eyebrow': 'YOUR AI CREW',
  'visual_title': 'Turn an idea into something real.',
  'visual_description': 'Sign in to continue conversations, save projects, and work with your personal AI team.',
  'visual_feature': 'Projects and team spaces stay securely in sync',
  'reason_auth_required': 'Sign in to continue',
  'reason_chat': 'Sign in to send messages and save conversations',
  'reason_knowledge': 'Sign in to access projects and knowledge bases',
  'reason_assets': 'Sign in to manage your assets',
  'reason_account': 'Sign in to view and manage your account',
  'reason_subscription': 'Sign in to view subscriptions and plans',
  'reason_invite': 'Sign in to view invitation rewards',
  'reason_image_recents': 'Sign in to view your recent creations',
  'reason_upload': 'Sign in to upload files and reference images',
  'reason_image_generation': 'Sign in to generate and save images',
  'reason_web_generation': 'Sign in to generate and save web projects',
  'reason_payment_result': 'Sign in to view your payment result',
  'mobile_pc_guide_title': 'Please use a computer to\nexperience Paiteams',
  'mobile_pc_guide_invite_title': 'Points have been added\nPlease use a computer to\nexperience Paiteams',
  'copyright': '© 2025 PAITEAMS. All rights reserved.'
}
